
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_1ckp6_66",
  "button": "awsui_button_vjswe_1ckp6_70",
  "variant-normal": "awsui_variant-normal_vjswe_1ckp6_132",
  "disabled": "awsui_disabled_vjswe_1ckp6_150",
  "variant-primary": "awsui_variant-primary_vjswe_1ckp6_157",
  "variant-link": "awsui_variant-link_vjswe_1ckp6_182",
  "variant-icon": "awsui_variant-icon_vjswe_1ckp6_207",
  "variant-control-group-action": "awsui_variant-control-group-action_vjswe_1ckp6_232",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_1ckp6_259",
  "variant-inline-icon-pointer-target": "awsui_variant-inline-icon-pointer-target_vjswe_1ckp6_284",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_1ckp6_309",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_1ckp6_338",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_1ckp6_363",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_1ckp6_388",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_1ckp6_418",
  "button-no-text": "awsui_button-no-text_vjswe_1ckp6_537",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_1ckp6_541",
  "full-width": "awsui_full-width_vjswe_1ckp6_544",
  "button-compact": "awsui_button-compact_vjswe_1ckp6_561",
  "icon-left": "awsui_icon-left_vjswe_1ckp6_584",
  "icon-right": "awsui_icon-right_vjswe_1ckp6_589",
  "icon": "awsui_icon_vjswe_1ckp6_584",
  "link": "awsui_link_vjswe_1ckp6_608",
  "disabled-with-reason": "awsui_disabled-with-reason_vjswe_1ckp6_608"
};
  